// TODO: should be marked as server-only
// import 'server-only';
import { Locale } from '@headless-workspace/config';
import { EcomConfigKeys, getCachedEcomConfigByKey } from '../config';

export const getCachedPriceLegalMentionsEnabled = async (locale: Locale) =>
    getCachedEcomConfigByKey<boolean>(locale, EcomConfigKeys.EnablePriceLegalMentions);
